import type { RouteObject } from 'react-router-dom';
import { ReleasedFeature } from '../../release';
import { RequirePermission } from '../auth/guards';
import { AgentsPage } from './AgentsPage';
import { CommissionMatrixDetailPage, CommissionMatrixPage } from './CommissionMatrixPages';
import { GroupEditPage } from './GroupEditPage';
import { GroupsPage } from './GroupsPage';
import { SearchUserPage } from './SearchUserPage';
import { UnlockUserPage } from './UnlockUserPage';
import { UserSettingsLayout } from './UserSettingsLayout';

const guard = (code: string, element: JSX.Element) => (
  <RequirePermission code={code}>{element}</RequirePermission>
);

/** User Settings (PC480) and Unlock User (PC238). */
export const usersRoutes: RouteObject[] = [
  {
    path: 'settings/users',
    element: <UserSettingsLayout />,
    children: [
      { path: 'groups', element: guard('PC12', <GroupsPage />) },
      { path: 'groups/:id', element: guard('PC12', <GroupEditPage />) },
      // `key` forces a fresh page (filters, paging) when switching between levels.
      { path: 'master', element: guard('PC120', <AgentsPage key="master" level="master" />) },
      {
        path: 'distributor',
        element: guard('PC121', <AgentsPage key="distributor" level="distributor" />),
      },
      { path: 'retailer', element: guard('PC122', <AgentsPage key="retailer" level="retailer" />) },
      { path: 'employee', element: guard('PC123', <AgentsPage key="employee" level="employee" />) },
      {
        path: 'admin',
        element: guard(
          'PC123',
          <ReleasedFeature name="add-administrator" page>
            <AgentsPage key="admin" level="admin" />
          </ReleasedFeature>,
        ),
      },
      { path: 'commission', element: guard('PC792', <CommissionMatrixPage />) },
      { path: 'commission/:id', element: guard('PC792', <CommissionMatrixDetailPage />) },
      { path: 'search', element: guard('PC871', <SearchUserPage />) },
    ],
  },
  { path: 'settings/unlock-user', element: guard('PC238', <UnlockUserPage />) },
];
